import { call, select, take, put } from 'redux-saga/effects'
import { get, last, omit } from 'lodash-es'
import { selectLocations } from './routerLocations'
import { LOGOUT } from './user'

// ------------------------------------
// Constants
// ------------------------------------
const LOCATION_CHANGE = 'LOCATION_CHANGE'
const CLOSE_MOD = 'CLOSE_MOD'
export const OPEN_MOD = 'OPEN_MOD'
export const REQUEST_OPEN_MOD = 'REQUEST_OPEN_MOD'
const OPEN_HELPER_MOD = 'OPEN_HELPER_MOD'
const UPDATE_HELPER_MOD = 'UPDATE_HELPER_MOD'
const CLOSE_HELPER_MOD = 'CLOSE_HELPER_MOD'
const SET_MOD_SCROLL = 'SET_MOD_SCROLL'
const SET_PREV_MOD_ADDITIONAL = 'SET_PREV_MOD_ADDITIONAL'

// ------------------------------------
// Actions
// ------------------------------------
export const openMod = payload => {
  return {
    type: REQUEST_OPEN_MOD,
    payload
  }
}

export const closeMod = () => {
  return {
    type: CLOSE_MOD,
    payload: {}
  }
}

export const openHelperMod = payload => ({
  type: OPEN_HELPER_MOD,
  payload
})

export const updateHelperMod = payload => ({
  type: UPDATE_HELPER_MOD,
  payload
})

export const closeHelperMod = () => ({
  type: CLOSE_HELPER_MOD
})

export function setModScroll(x, y) {
  return {
    type: SET_MOD_SCROLL,
    payload: {
      x,
      y
    }
  }
}

export const setPrevModAdditional = payload => ({
  type: SET_PREV_MOD_ADDITIONAL,
  payload
})

function* setOpenMod(action) {
  const locations = yield select(selectLocations)
  yield put({
    type: OPEN_MOD,
    payload: { ...action.payload, startLocation: locations[locations.length >= 2 ? locations.length - 2 : 0].pathname }
  })
}

function* openModSaga() {
  while (true) {
    const action = yield take(REQUEST_OPEN_MOD)
    yield call(setOpenMod, action)
  }
}

export const sagas = [openModSaga]

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  list: [],
  sublist: [],
  startLocation: null,
  scrollPosition: 0,
  initialLength: 0
}

export default function(state = initialState, { type, payload }) {
  const latest = state.list[state.list.length - 1]
  const current = last(state.list.filter(i => i.href === get(payload, 'id')))
  switch (type) {
    case OPEN_MOD: {
      if (latest && latest.type === payload.type && latest.href === payload.href) {
        return state
      } else {
        return {
          ...state,
          list: state.list.length
            ? [
                ...state.list.slice(0, -1),
                ...[{ ...last(state.list), y: (document.getElementById('dim-screen') || {}).scrollTop }],
                ...[omit(payload, ['startLocation'])]
              ]
            : [...state.list, ...[omit(payload, ['startLocation'])]],
          startLocation: state.list.length ? state.startLocation : payload.startLocation,
          scrollPosition: window.scrollY,
          sublist: state.sublist
        }
      }
    }
    case OPEN_HELPER_MOD: {
      return {
        ...state,
        sublist: [...state.sublist, payload]
      }
    }
    case UPDATE_HELPER_MOD: {
      const latest = last(state.sublist)
      for (let i in payload) {
        latest[i] = payload[i]
      }
      return state
    }
    case CLOSE_HELPER_MOD: {
      return {
        ...state,
        sublist: state.sublist.slice(0, -1)
      }
    }
    case SET_PREV_MOD_ADDITIONAL: {
      if (current && state.list.length > payload.size) {
        for (let i in payload) {
          current[i] = payload[i]
        }
      }
      return {
        ...state
      }
    }
    case CLOSE_MOD: {
      if (state.list.length) {
        return Object.assign({}, state, { list: state.list.slice(0, -1) })
      } else {
        return initialState
      }
    }
    case LOCATION_CHANGE:
      if (payload.action === 'POP' && state.list.length && !state.sublist.length) {
        return Object.assign({}, state, { list: state.list.slice(0, -1) })
      } else {
        return state
      }
    case LOGOUT: {
      return initialState
    }
    default: {
      return state
    }
  }
}
